import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export interface ValidationState {
    validations: any
}

const initialState: ValidationState = {
    validations: null
}

export const validationSlice = createSlice({
    name: 'validation',
    initialState,
    reducers: {
        getValidations: (state) => {
            void state;
        },
        setValidations: (state, action: PayloadAction<any>) => {
            state.validations = action.payload
        }
    }
})

export const {
    getValidations,
    setValidations,
} = validationSlice.actions

export default validationSlice.reducer
